import { HomeOutlined, WhatsAppOutlined, TeamOutlined, UserOutlined, PictureOutlined, CarOutlined, DollarOutlined, FileTextOutlined, GlobalOutlined, ShoppingCartOutlined, CheckCircleOutlined, UndoOutlined, SearchOutlined, EditOutlined } from '@ant-design/icons'
import Constants from '../utils/constants'

export const getMenuItems = (navigate, isMobile, setCollapsed, userRole) => {
  const adminMenuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'Home',
      onClick: () => {
        navigate('/')
        if (isMobile) setCollapsed(true)
      }
    },
        {
      key: 'orders',
      icon: <ShoppingCartOutlined />,
      label: 'Orders',
      children: [
        {
          key: '/orders/new',
          icon: <ShoppingCartOutlined />,
          label: 'New Orders',
          onClick: () => {
            navigate('/orders/new')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/orders/completed',
          icon: <CheckCircleOutlined />,
          label: 'Completed Orders',
          onClick: () => {
            navigate('/orders/completed')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/orders/refunded',
          icon: <UndoOutlined />,
          label: 'Refunded Orders',
          onClick: () => {
            navigate('/orders/refunded')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/orders/search',
          icon: <SearchOutlined />,
          label: 'Search Orders',
          onClick: () => {
            navigate('/orders/search')
            if (isMobile) setCollapsed(true)
          }
        }
      ]
    },
    {
      key: '/employees',
      icon: <TeamOutlined />,
      label: 'Employees',
      onClick: () => {
        navigate('/employees')
        if (isMobile) setCollapsed(true)
        }
    },
    {
      key: '/users',
      icon: <UserOutlined />,
      label: 'Users',
      onClick: () => {
        navigate('/users')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/banners',
      icon: <PictureOutlined />,
      label: 'Banners',
      onClick: () => {
        navigate('/banners')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: 'border-tax',
      icon: <GlobalOutlined />,
      label: 'Border Tax',
      children: [
        {
          key: '/border-tax/states',
          icon: <GlobalOutlined />,
          label: 'Create State',
          onClick: () => {
            navigate('/border-tax/states')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/border-tax/tax-modes',
          icon: <CarOutlined />,
          label: 'Create Tax Mode',
          onClick: () => {
            navigate('/border-tax/tax-modes')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/border-tax/prices',
          icon: <DollarOutlined />,
          label: 'Create Price',
          onClick: () => {
            navigate('/border-tax/prices')
            if (isMobile) setCollapsed(true)
          }
        }
      ]
    },
    {
      key: 'road-tax',
      icon: <CarOutlined />,
      label: 'Road Tax',
      children: [
        {
          key: '/road-tax/states',
          icon: <GlobalOutlined />,
          label: 'Create State',
          onClick: () => {
            navigate('/road-tax/states')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/road-tax/tax-modes',
          icon: <CarOutlined />,
          label: 'Create Tax Mode',
          onClick: () => {
            navigate('/road-tax/tax-modes')
            if (isMobile) setCollapsed(true)
          }
        },
        {
          key: '/road-tax/prices',
          icon: <DollarOutlined />,
          label: 'Create Price',
          onClick: () => {
            navigate('/road-tax/prices')
            if (isMobile) setCollapsed(true)
          }
        }
      ]
    },
    {
      key: 'all-india-permit',
      icon: <FileTextOutlined />,
      label: 'All India Permit',
      children: [
        {
          key: '/all-india-permit/price',
          icon: <DollarOutlined />,
          label: 'Price',
          onClick: () => {
            navigate('/all-india-permit/price')
            if (isMobile) setCollapsed(true)
          }
        }
      ]
    },
    {
      key: 'all-india-tax',
      icon: <CarOutlined />,
      label: 'All India Tax',
      children: [
        {
          key: '/all-india-tax/price',
          icon: <DollarOutlined />,
          label: 'Add Price',
          onClick: () => {
            navigate('/all-india-tax/price')
            if (isMobile) setCollapsed(true)
          }
        }
      ]
    },
    {
      key: '/message',
      icon: <WhatsAppOutlined />,
      label: 'Message',
      onClick: () => {
        navigate('/message')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/notes',
      icon: <EditOutlined />,
      label: 'Notes',
      onClick: () => {
        navigate('/notes')
        if (isMobile) setCollapsed(true)
      }
    },
  ]

  const managerMenuItems = [
    {
      key: '/orders/new',
      icon: <ShoppingCartOutlined />,
      label: 'New Orders',
      onClick: () => {
        navigate('/orders/new')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/orders/completed',
      icon: <CheckCircleOutlined />,
      label: 'Completed Orders',
      onClick: () => {
        navigate('/orders/completed')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/orders/refunded',
      icon: <UndoOutlined />,
      label: 'Refunded Orders',
      onClick: () => {
        navigate('/orders/refunded')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/orders/search',
      icon: <SearchOutlined />,
      label: 'Search Orders',
      onClick: () => {
        navigate('/orders/search')
        if (isMobile) setCollapsed(true)
      }
    }
  ]

  if (userRole === Constants.ROLES.ADMIN) {
    return adminMenuItems
  }

  if (userRole === Constants.ROLES.MANAGER) {
    return managerMenuItems
  }

  return []
}